import React from "react";
import { Spinner as BootstrapSpinner, SpinnerProps } from "react-bootstrap";

const Spinner = (props: SpinnerProps): JSX.Element => {
  return <BootstrapSpinner {...props} as="div" />;
};

export default Spinner;
